<template>
   <div id="landing">
      <div class="header-row">
         <div class="header">
            <div class="content">
               HOMAM
            </div>
         </div>
      </div>
   </div>      
</template>

<script>
export default {
   name: 'Landing',
   data () {
      return {
         msg: '',
         copyrightYear: (new Date()).getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false
      }
   },
   computed: {
   },
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* + General Page Style */
#landing { 
   height: 100vh;
   overflow-x: hidden;
   overflow-y: hidden;
}

/* - General Page Style */

/* + Header Row */
.header-row {
   display: grid;
   grid-template-rows: 88% 12%;
   border-bottom: solid 1px #DDDDDD;
   background-color: white;
   height: 100vh;
}

.header {
   display: flex;
   align-items: center;
   justify-content: center;
}

.content {
   font-size: 4rem;
   color: black;
}
/* - Header Row */

/* + Responsive UI */
@media screen and (max-width: 960px) {
}

@media screen and (max-width: 640px) {
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/Landing.vue